import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SelectionButtonProps } from "../utils/types";
import { DATE_FORMAT_OPTIONS, TIME_FORMAT_OPTIONS } from "../utils/constants";
import {
  setTimeFormat,
  setDateFormat,
} from "../../../redux/slices/dateTimeFormatSlice";
import { RootState } from "../../../redux/store";

const SelectionButton = ({
  isSelected,
  label,
  onClick,
}: SelectionButtonProps) => (
  <div className="flex items-center gap-[5px] cursor-pointer" onClick={onClick}>
    <div className="border border-border-gray dark:border-border-gray-dk w-[12px] h-[12px] rounded-full flex items-center justify-center">
      {isSelected && (
        <span className="w-[6px] h-[6px] bg-verba-blue-dark-mode dark:bg-verba-blue-dark-mode-dk rounded-full" />
      )}
    </div>
    <p className="text-md font-normal text-heading-text dark:text-heading-text-dk">
      {label}
    </p>
  </div>
);

const DateAndTimeFormat = () => {
  const dispatch = useDispatch();
  const { timeFormat, dateFormat } = useSelector(
    (state: RootState) => state.dateTimeFormat
  );

  return (
    <div className="flex flex-col gap-[24px] px-[24px] py-[16px]">
      <p className="text-base font-normal text-data dark:text-data-dk">
        Customise your dashboard by changing the date & time format
      </p>
      <div className="flex flex-col gap-[8px]">
        <h3 className="text-md font-medium text-verba-field-label dark:text-verba-field-label-dk">
          Time Format
        </h3>
        <div className="flex flex-col gap-[8px]">
          {Object.entries(TIME_FORMAT_OPTIONS).map(([value, label]) => (
            <SelectionButton
              key={value}
              isSelected={timeFormat === value}
              label={label}
              onClick={() =>
                dispatch(
                  setTimeFormat(value as keyof typeof TIME_FORMAT_OPTIONS)
                )
              }
            />
          ))}
        </div>
      </div>

      <hr className="border-border-gray dark:border-border-gray-dk" />

      <div className="flex flex-col gap-[8px]">
        <h3 className="text-md font-medium text-verba-field-label dark:text-verba-field-label-dk">
          Date Format
        </h3>
        <div className="flex flex-col gap-[8px]">
          {DATE_FORMAT_OPTIONS.map((format) => (
            <SelectionButton
              key={format?.value}
              isSelected={dateFormat === format?.value}
              label={format?.label}
              onClick={() => dispatch(setDateFormat(format?.value))}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DateAndTimeFormat;
